import {formatearNum} from '../../../../utils/moneda.utils';
import {aMonto, redondear2} from '../../../../utils/calculo-dte';
import {TIPO_DTE, esDocumentoNormativaV2} from '../../../../utils/version-documento.utils';

export {formatearNum};

export const SIN_MONTO = '--'

const montoONulo = (valor: any): number | null => {
  if (valor === null || valor === undefined || `${valor}`.trim() === '') return null
  const numero = Number(`${valor}`.trim())
  return Number.isFinite(numero) ? numero : null
}

export const montoOGuion = (valor: any): string => formatearNum(montoONulo(valor)) ?? SIN_MONTO

// Descuento global del documento (resumen.descuNoSuj + descuExenta + descuGravada); 0 en documentos sin descuento global
export const descuentoGlobalDe = (resumen: any): number =>
  redondear2(aMonto(resumen?.descuNoSuj) + aMonto(resumen?.descuExenta) + aMonto(resumen?.descuGravada))

// Credito fiscal, nota credito y debito
export const TotalesCFF = ({resumen}: {resumen: any}) => {
  return (
    <>
      {(resumen) &&
      (
      <tbody>
        <tr className="cf-subtotal">
            <td>Suma de operaciones</td>
            <td>{formatearNum(resumen?.subTotalVentas) ?? '--'}</td>
        </tr>
        {descuentoGlobalDe(resumen) > 0 && (
        <tr className="cf-descuento">
            <td>Descuento global</td>
            <td>-{formatearNum(descuentoGlobalDe(resumen))}</td>
        </tr>
        )}
        <tr className="cf-subtotal">
            <td>Impuesto al Valor Agregado 13%</td>
            <td>{formatearNum(resumen?.tributos[0]?.valor)}</td>
        </tr>
        <tr className="cf-subtotal">
            <td>Otros impuestos</td>
            <td>{formatearNum(resumen?.totalTributosSinIva) ?? '--'}</td>
        </tr>
        <tr className="cf-subtotal">
            <td>Subtotal</td>
            <td>{formatearNum(resumen?.montoTotalOperacion) ?? '--'}</td>
        </tr>
        <tr className="cf-subtotal">
            <td>IVA percibido 1%</td>
            <td>{formatearNum(resumen?.ivaPerci1 ?? resumen?.ivaPerci) ?? '--'}</td>
        </tr>
        <tr className="cf-subtotal">
            <td>IVA retenido 1%</td>
            <td>{formatearNum(resumen?.ivaRete1 ?? resumen?.ivaRete) ?? '--'}</td>
        </tr>
        <tr className="cf-descuento">
            <td>Retencion renta 10%</td>
            <td>{formatearNum(resumen?.reteRenta) ?? '--'}</td>
        </tr>
        <tr className="cf-subtotal">
            <td>Total Otros Montos No Afectados</td>
            <td>{formatearNum(resumen?.totalNoGravado ?? 0)}</td>
        </tr>
        <tr className="cf-total">
            <td>Total</td>
            <td>{formatearNum(resumen?.totalPagar) ?? formatearNum(resumen?.montoTotalOperacion) ?? '--'}</td>
        </tr>
      </tbody>
      )}
    </>
  )
}

export const TotalesCF = ({resumen}: {resumen: any}) => {
  return (
    <>
      {(resumen) &&
      (
      <tbody>
        <tr className="cf-subtotal">
            <td>Suma de operaciones</td>
            <td>{formatearNum(resumen?.subTotalVentas) ?? '--'}</td>
        </tr>
        {descuentoGlobalDe(resumen) > 0 && (
        <tr className="cf-descuento">
            <td>Descuento global</td>
            <td>-{formatearNum(descuentoGlobalDe(resumen))}</td>
        </tr>
        )}
        <tr className="cf-subtotal">
            <td>Impuesto al Valor Agregado 13%</td>
            <td>{formatearNum(resumen?.totalIva) ?? '--'}</td>
        </tr>
        <tr className="cf-subtotal">
            <td>Subtotal</td>
            <td>{formatearNum(redondear2(aMonto(resumen?.subTotalVentas) - descuentoGlobalDe(resumen))) ?? '--'}</td>
        </tr>
        <tr className="cf-subtotal">
            <td>Otros impuestos</td>
            <td>{formatearNum(resumen?.totalTributosSinIva) ?? '--'}</td>
        </tr>
        <tr className="cf-subtotal">
            <td>IVA percibido 1%</td>
            <td>{formatearNum(resumen?.ivaPerci1 ?? resumen?.ivaPerci) ?? '--'}</td>
        </tr>
        <tr className="cf-subtotal">
            <td>IVA retenido 1%</td>
            <td>{formatearNum(resumen?.ivaRete1 ?? resumen?.ivaRete) ?? '--'}</td>
        </tr>
        <tr className="cf-descuento">
            <td>Retencion renta 10%</td>
            <td>{formatearNum(resumen?.reteRenta) ?? '--'}</td>
        </tr>
        <tr className="cf-subtotal">
            <td>Total Otros Montos No Afectados</td>
            <td>{formatearNum(resumen?.totalNoGravado ?? 0)}</td>
        </tr>
        <tr className="cf-total">
            <td>Total</td>
            <td>{formatearNum(resumen?.totalPagar) ?? formatearNum(resumen?.montoTotalOperacion) ?? '--'}</td>
        </tr>
      </tbody>
      )}
    </>
  )
}

export const TotalesSujeto = ({resumen}: {resumen: any}) => {
  return (
    <>
      {(resumen) && 
      (
      <tbody>
        <tr className="cf-subtotal">
            <td>Suma de operaciones</td>
            <td>{formatearNum(resumen?.totalCompra) ?? '--'}</td>
        </tr>
        <tr className="cf-subtotal">
            <td>Impuesto al Valor Agregado 13%</td>
            <td>{'--'}</td>
        </tr>
        <tr className="cf-subtotal">
            <td>Subtotal</td>
            <td>{formatearNum(resumen?.subTotal) ?? '--'}</td>
        </tr>
        <tr className="cf-subtotal">
            <td>IVA percibido 1%</td>
            <td>{formatearNum(resumen?.ivaPerci1 ?? resumen?.ivaPerci) ?? '--'}</td>
        </tr>
        <tr className="cf-subtotal">
            <td>IVA retenido 1%</td>
            <td>{formatearNum(resumen?.ivaRete1 ?? resumen?.ivaRete) ?? '--'}</td>
        </tr>
        <tr className="cf-descuento">
            <td>Retencion renta 10%</td>
            <td>{formatearNum(resumen?.reteRenta) ?? '--'}</td>
        </tr>
        <tr className="cf-total">
            <td>Total</td>
            <td>{formatearNum(resumen?.totalPagar) ?? formatearNum(resumen?.montoTotalOperacion) ?? '--'}</td>
        </tr>
      </tbody>
      )}
    </> 
  )
}

export const TotalesCL = ({resumen}: {resumen: any}) => {
  return (
    <>
      {(resumen) && 
      (
      <tbody>
        <tr className="cf-subtotal">
            <td>Total de operaciones no sujetas</td>
            <td>{formatearNum(resumen?.totalNoSuj) ?? '$0.00'}</td>
        </tr>
        <tr className="cf-subtotal">
            <td>Total de operaciones exentas</td>
            <td>{formatearNum(resumen?.totalExenta) ?? '$0.00'}</td>
        </tr>
        <tr className="cf-subtotal">
            <td>Total de operaciones gravadas</td>
            <td>{formatearNum(resumen?.totalGravada) ?? '$0.00'}</td>
        </tr>
        <tr className="cf-subtotal">
            <td>Total de operaciones de exportación</td>
            <td>{formatearNum(resumen?.totalExportacion) ?? '$0.00'}</td>
        </tr>
        <tr className="cf-subtotal">
            <td>Monto total de la operación</td>
            <td>{formatearNum(resumen?.montoTotalOperacion) ?? '$0.00'}</td>
        </tr>
        <tr className="cf-subtotal">
            <td>Impuesto al Valor Agregado 13%</td>
            <td>{formatearNum(resumen?.tributos?.find((imp: any) => imp.codigo === '20')?.valor) ?? '--'}</td>
        </tr>
        <tr className="cf-subtotal">
            <td>IVA percibido 1%</td>
            <td>{formatearNum(resumen?.ivaPerci) ?? '--'}</td>
        </tr>
        <tr className="cf-total">
            <td>Total</td>
            <td>{montoOGuion(resumen?.total ?? resumen?.montoTotalOperacion)}</td>
        </tr>
      </tbody>
      )}
    </> 
  )
}

export const sumaOperacionesExportacion = (resumen: any, esVersionDos: boolean): any =>
  esVersionDos ? resumen?.totalGravada ?? resumen?.montoTotalOperacion : resumen?.totalPagar

export const subtotalExportacion = (resumen: any, esVersionDos: boolean): any =>
  esVersionDos ? resumen?.montoTotalOperacion : resumen?.expSubtotal

export const descuentoExportacion = (resumen: any, esVersionDos: boolean): any =>
  esVersionDos ? resumen?.descuGravada ?? resumen?.totalDescu : resumen?.descuentoGlobal

export const totalExportacion = (resumen: any, esVersionDos: boolean): any =>
  esVersionDos ? resumen?.totalPagar ?? resumen?.montoTotalOperacion : resumen?.extTotal

export const esExportacionVersionDos = (versionDte: any): boolean =>
  esDocumentoNormativaV2(TIPO_DTE.FACTURA_EXPORTACION, Number(`${versionDte ?? ''}`.trim()))

export const TotalesExportacion = ({resumen, versionDte}: {resumen: any; versionDte?: any}) => {
  const esVersionDos = esExportacionVersionDos(versionDte)

  return (
    <>
      {(resumen) && 
      (
      <tbody>
        <tr className="cf-subtotal">
            <td>Suma de operaciones</td>
            <td>{montoOGuion(sumaOperacionesExportacion(resumen, esVersionDos))}</td>
        </tr>
        <tr className="cf-subtotal">
            <td>Seguro</td>
            <td>{montoOGuion(resumen?.seguro)}</td>
        </tr>
        <tr className="cf-subtotal">
            <td>Flete</td>
            <td>{montoOGuion(resumen?.flete)}</td>
        </tr>
        <tr className="cf-subtotal">
            <td>Subtotal</td>
            <td>{montoOGuion(subtotalExportacion(resumen, esVersionDos))}</td>
        </tr>
        <tr className="cf-descuento">
            <td>Descuento</td>
            <td>{montoOGuion(descuentoExportacion(resumen, esVersionDos))}</td>
        </tr>
        <tr className="cf-total">
            <td>Total</td>
            <td>{montoOGuion(totalExportacion(resumen, esVersionDos))}</td>
        </tr>
      </tbody>
      )}
    </> 
  )
}

export const TotalesNotaRemision = ({resumen}: {resumen: any}) => {
  return (
    <>
      {(resumen) && 
      (
      <tbody>
        <tr className="cf-subtotal">
            <td>Suma de operaciones</td>
            <td>{formatearNum(resumen?.totalGravada) ?? '--'}</td>
        </tr>
        <tr className="cf-subtotal">
            <td>Impuesto al Valor Agregado 13%</td>
            <td>{formatearNum(resumen?.tributos[0]?.valor)}</td>
        </tr>
        <tr className="cf-subtotal">
            <td>Otros impuestos</td>
            <td>{formatearNum(resumen?.totalTributosSinIva) ?? '--'}</td>
        </tr>
        <tr className="cf-subtotal">
            <td>Subtotal</td>
            <td>{formatearNum(resumen?.subTotalVentas) ?? '--'}</td>
        </tr>
        <tr className="cf-subtotal">
            <td>IVA percibido 1%</td>
            <td>{formatearNum(resumen?.ivaPerci1 ?? resumen?.ivaPerci) ?? '--'}</td>
        </tr>
        <tr className="cf-subtotal">
            <td>IVA retenido 1%</td>
            <td>{formatearNum(resumen?.ivaRete1 ?? resumen?.ivaRete) ?? '--'}</td>
        </tr>
        <tr className="cf-descuento">
            <td>Retencion renta 10%</td>
            <td>{formatearNum(resumen?.reteRenta) ?? '--'}</td>
        </tr>
        <tr className="cf-total">
            <td>Total</td>
            <td>{formatearNum(resumen?.totalPagar) ?? formatearNum(resumen?.montoTotalOperacion) ?? '--'}</td>
        </tr>
      </tbody>
      )}
    </> 
  )
}


export const TotalesComprobanteRetencion = ({resumen}: {resumen: any}) => {
  return (
    <>
      {(resumen) && 
      (
      <tbody>
        <tr className="cf-total">
            <td>Total monto sujeto a retención</td>
            <td>{formatearNum(resumen?.totalSujetoRetencion) ?? '--'}</td>
        </tr>
        <tr className="cf-descuento">
            <td>Total IVA retenido:</td>
            <td>{formatearNum(resumen?.totalIVAretenido) ?? '--'}</td>
        </tr>
      </tbody>
      )}
    </> 
  )
}
